import './style.scss';
import React, { useState, useRef, useEffect } from 'react';
import { GrFormNextLink } from 'react-icons/gr';
import useSrcSetVerify from '../../../pctHooks/useSrcSetVerify';
import useMediaQuery from '../../../pctHooks/useMediaQuery';
import SVG from 'react-inlinesvg';
import NiceModal from '@ebay/nice-modal-react';
import { Button as BootstrapButton } from 'react-bootstrap';

import { connect } from 'react-redux';
import { updatePreTest } from 'actions';
import { getEquivalences } from 'services/api';

import { BsLockFill } from 'react-icons/bs';

import {
    Text,
    Label,
    Button,
    Image,
    Rate,
    ProgressBar,
    Duration,
    Visualization,
    ButtonCertificate,
    Like,
    ViewSyllabus,
    EnrollmentProcessing,
} from '../../atoms';
import useCards from 'pctHooks/useCards';
import BadgeNewContent from 'pctComponents/BadgeNewContent';
import ModalEquivalencyPages from 'pctComponents/modals/ModalEquivalencyPages';
import {
    getEvaluationKnowledgeCardInfo,
    EvaluationKnowledgeRetry,
    EvaluationKnowledgeGradeText,
} from '../EvaluationKnowledgeCardInfo';

type Props = {
    className?: string;
    data: any;
    level?: boolean;
    btnInfo?: string;
    type?: string;
    _parentData?: any;
    size?: any;
    elemType?: string | null;
    elemId?: any;
    configPreTest?: {
        statusPreTest: Boolean | null;
    };
};

const Banner = (props: Props) => {
    const { data, type = 'level', className = '', _parentData, size = 'l', elemType = null, elemId = null } = props;

    const setProgressStateRef = useRef(null as any);
    const progressInfoRef = useRef(null as any);
    const dragStartRef = useRef<{ x: number; y: number } | null>(null);
    const isDraggingRef = useRef(false);

    let btnInfo = '';

    let collection: any = { data: data, elementType: '', idElement: elemId };
    let elementType = collection.data.idNode ? 'NODE' : 'CONTENT';

    elementType = elemType ? elemType : elementType;
    collection.elementType = elementType;

    if (data.hasOwnProperty('contentEnrollment') || collection.elementType === 'EVALUATION') {
        collection.idNodeEnrollment = data?.contentEnrollment?.idNodeEnrollment
            ? data?.contentEnrollment?.idNodeEnrollment
            : _parentData?.node?.nodeEnrollment?.idNodeEnrollment;
        collection.idEnrollment = data?.contentEnrollment?.enrollment?.idEnrollment
            ? data?.contentEnrollment?.enrollment?.idEnrollment
            : _parentData?.node?.nodeEnrollment?.enrollment?.idEnrollment ||
              _parentData?.node?.nodeEnrollment?.idEnrollment;
    }

    const {
        image,
        concluidedText,
        isEnrollment,
        canEnrollment,
        noTeamAvaliable,
        initialProgressState,
        statusRegistered,
        handleCardMouseEvent,
        handleCertificateMouseEvent,
        hasCertificate,
        statusElement,
        verifyCompletedStatus,
        nodeAvailable,
        prerequisitesMet,
        classNotStartedYet,
        preRequisiteBlockMet,
        updateProcessing,
        processingStatus,
    } = useCards({
        collection: collection,
        dataParent: _parentData,
        setProgressStateRef,
        progressInfoRef,
    });

    const [progressInfo, setProgressState] = useState(initialProgressState());
    const [equivalencePages, setEquivalencePages] = useState([]);
    const { equivalentNodeCode } = collection?.data?.nodeEnrollment || {};
    const hasEquivalence = Boolean(equivalentNodeCode);
    const evaluationKnowledgeInfo = getEvaluationKnowledgeCardInfo(collection);
    
    const configPreTest = props.configPreTest?.statusPreTest || false;

    useEffect(() => {
        (async () => {
            if (!hasEquivalence) {
                return;
            }

            try {
                const {
                    data: { result },
                } = await getEquivalences(collection?.data?.idNode || 0);
                setEquivalencePages(result.map((page) => ({ title: page.origin.title })));
            } catch (error) {}
        })();
    }, [data?.idNode, equivalentNodeCode, hasEquivalence]);

    setProgressStateRef.current = setProgressState;
    progressInfoRef.current = progressInfo;

    const { rate, label, title, description, workload, views, entryPoint, newlyAvailable, newContentInternal } = data;
    const textBadge = newContentInternal ? 'Novo' : 'Novos conteúdos';

    const tabletStatus = useMediaQuery('lg');
    const mobileStatus = useMediaQuery('sm');
    const sizeConvert = (format) => {
        const foSize = {
            l: 'landscape-large',
            m: 'landscape-middle',
            s: 'landscape-small',
        };

        return foSize[format] ?? 'landscape-large';
    };

    const formatSize = mobileStatus ? 'portrait' : tabletStatus ? 'landscape-large' : sizeConvert(size);
    const imgBase = (statusElement() === 'ARCHIVED' || !nodeAvailable()) && image().image ? image().image : image();
    const srcSetVerify = useSrcSetVerify(imgBase, formatSize);
    const imagePath = srcSetVerify || imgBase;
    
    const isCardBlocked =
        preRequisiteBlockMet ||
        !prerequisitesMet() ||
        statusRegistered() === 'inactive' ||
        statusElement() === 'ARCHIVED' ||
        classNotStartedYet();

    if (type === 'level' && entryPoint != null) {
        //AQUI PRECISA SER CRIADA A LÓGICA DE MATRICULA OU DE INICIAR O TREINAMENTO.
        if (isEnrollment()) {
            //Acessa o treinamento, pois já possí matricula ativa.
            btnInfo = 'Iniciar';
            // pathLink = `/level/{${idEnrollment}`;
        } else if (canEnrollment()) {
            //Apresenta o quadro para escolher uma turma.
            btnInfo = 'Matricular-se';
        }
        //  else if (noTeamAvaliable()) {
        //     //Realiza a auto matricula
        //     btnInfo = 'Matricular-se';
        // }
    } else if (collection.elementType === 'CONTENT' || collection.elementType === 'EVALUATION') {
        btnInfo = 'Iniciar';
    }

    if (evaluationKnowledgeInfo.showEvaluationRetry) {
        btnInfo = 'Tentar Novamente';
    }

    if (isCardBlocked) {
        btnInfo = '';
    }

    const handleCard = (e: React.MouseEvent<HTMLElement>) => {
        if (configPreTest) {
            e.stopPropagation();
            return;
        }

        handleCardMouseEvent(e);
    };

    const handleCertificate = (e: React.MouseEvent<HTMLElement>) => {
        if (configPreTest) {
            e.stopPropagation();
            return;
        }

        handleCertificateMouseEvent(e);
    };

    const showEquivalenceModal = () => {
        NiceModal.show(ModalEquivalencyPages, {
            obj: {
                pages: equivalencePages,
            },
        });
    };

    const handleEquivalence = (e: React.MouseEvent<HTMLElement>) => {
        if (configPreTest) {
            e.stopPropagation();
            return;
        }

        if (hasEquivalence) {
            showEquivalenceModal();
        }

        e.stopPropagation();
    };

    
    return (
        <div
            className={`pctMolecule pctBanner ${className} ${isCardBlocked ? 'pctBannerLock' : ''} ${
                !nodeAvailable() ? 'pctBannerLock02' : ''
            }`}
            data-aspectratio={formatSize}
            style={{
                cursor: processingStatus ? 'not-allowed' : 'default',
            }}
        >
            {image && (
                <>
                    <div className="containerImg">
                        {collection.data.link !== '' && collection.data.link !== null && (
                            <a href={collection.data.link} target="_blank">
                                {collection.data.image && (
                                    <>
                                        <Image className="imgBanner" path={imagePath} pathSet={srcSetVerify} />
                                    </>
                                )}

                                {!collection.data.image && (
                                    <div className="thumb">{image() && <SVG src={imgBase} />}</div>
                                )}
                            </a>
                        )}

                        {(collection.data.link === '' || collection.data.link === null) && (
                            <>
                                {collection.data.image && (
                                    <>
                                        <Image className="imgBanner" path={imagePath} pathSet={srcSetVerify} />
                                    </>
                                )}

                                {!collection.data.image && (
                                    <div className="thumb">{image() && <SVG src={imgBase} />}</div>
                                )}
                            </>
                        )}

                        <div className="imgEffect"></div>
                    </div>
                </>
            )}
            {elementType !== 'IMAGE' && (
                <div className="banner-container">
                    <div className="banner-container-base">
                        {rate && <Rate text="Avalie" />}
                        <div className="contaLabel">
                            {label && <Label text={label} />}
                            <ViewSyllabus collection={collection} />
                            <Like
                                // direction="invert"
                                collection={{
                                    ...collection,
                                    idElement: elemId,
                                    elementType: elemType,
                                }}
                                disabled={processingStatus || !!configPreTest}
                                statusRegistered={statusRegistered()}
                                className="likeSmall"
                            />
                            {newlyAvailable && <BadgeNewContent text={textBadge} className="inline" />}
                            {isCardBlocked && (
                                <div className="lockBlock">
                                    <BsLockFill className="lock" />
                                </div>
                            )}
                        </div>

                        {title && <Text component="h1" text={title} />}

                        {description && type === 'level' && (
                            <Text component="div" text={description} className={'description'} />
                        )}

                        {type !== 'IMAGE' && (
                            <div className="containerBtns" {...(btnInfo === '' ? { style: { display: 'none' } } : {})}>
                                {btnInfo !== '' && (
                                    <>
                                        {evaluationKnowledgeInfo.isKnowledgeEvaluation && (
                                            <div className="evaluationKnowledgeAttemptsText">
                                                {evaluationKnowledgeInfo.evaluationAttemptsMessage}
                                            </div>
                                        )}
                                        <Button
                                            ico={GrFormNextLink}
                                            text={btnInfo}
                                            callEvent={handleCard}
                                            className="button01"
                                        />
                                        {evaluationKnowledgeInfo.evaluationConcluidedMessage && (
                                            <Text
                                                component="small"
                                                text={`${evaluationKnowledgeInfo.evaluationConcluidedMessage}`}
                                                className={''}
                                            />
                                        )}
                                    </>
                                )}
                            </div>
                        )}

                        {type !== 'level' && (
                            <div className="progressInfo">
                                {progressInfo > 0 && (
                                    <ProgressBar
                                        collection={collection}
                                        percentage={progressInfo}
                                        status={statusElement()}
                                    />
                                )}

                                <div className="certificateProgress">
                                    <BootstrapButton
                                        className={hasEquivalence ? 'clickable-label' : ''}
                                        onClick={handleEquivalence}
                                    >
                                        {evaluationKnowledgeInfo.isKnowledgeEvaluation &&
                                        evaluationKnowledgeInfo.hasFinishedEvaluation ? (
                                            <EvaluationKnowledgeGradeText
                                                info={evaluationKnowledgeInfo}
                                                className={`textProgress ${
                                                    progressInfo < 100 ? 'progress' : 'finished'
                                                }`}
                                            />
                                        ) : (
                                            <Text
                                                component="small"
                                                className={`textProgress ${
                                                    progressInfo < 100 ? 'progress' : 'finished'
                                                }`}
                                                text={concluidedText()}
                                            />
                                        )}
                                    </BootstrapButton>
                                    {hasCertificate() && (
                                        <ButtonCertificate
                                            verifyCompletedStatus={verifyCompletedStatus()}
                                            onClick={handleCertificate}
                                        />
                                    )}
                                </div>
                            </div>
                        )}

                        {workload > 0 && (
                            <div className="containerInfo">
                                {workload ? <Duration text={workload} timeFormat={'seconds'} /> : null}
                            </div>
                        )}

                        {views > 0 && (
                            <div className="containerInfo">{views >= 0 ? <Visualization text={views} /> : null}</div>
                        )}
                    </div>
                </div>
            )}
            <EnrollmentProcessing
                processing={processingStatus}
                collection={collection}
                updateProcessing={updateProcessing}
            />
        </div>
    );
};

const mapStateToProps = (store) => ({
    configPreTest: store.configPreTestState,
});

const mapDispatchToProps = (dispatch) => ({
    updatePreTest: (item) => dispatch(updatePreTest(item)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Banner);
